export enum EAboutTypes {
    TEXT_EDITOR = 0,
    DYNAMIC_ITEMS = 1,
    IMAGE_EDITOR = 2
}
